module.exports = __webpack_public_path__ + "img/menu5.527eeba9.png";